export enum ApplicationStatus {
    InReview = 'In Review',
    Pending = 'Pending',
    Inactive = 'Inactive',
    Active = 'Active',
    Declined = 'Declined',
    Cancelled = 'Cancelled',
}
